'use client';

// Skeleton loading component for room cards
export default function RoomSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden animate-pulse">
      <div className="flex flex-col md:flex-row">
        {/* Left Section: Image Skeleton */}
        <div className="md:w-1/3">
          <div className="relative h-64 md:h-full bg-gray-200">
            {/* Image placeholder */}
            <div className="w-full h-full bg-gray-300"></div>
            
            {/* Navigation dots skeleton */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
            </div>
          </div>
        </div>

        {/* Right Section: Room Info Skeleton */}
        <div className="md:w-2/3 p-6">
          <div className="flex flex-col h-full">
            {/* Room title skeleton */}
            <div className="h-6 bg-gray-300 rounded w-3/4 mb-3"></div>
            
            {/* Room description skeleton */}
            <div className="space-y-2 mb-4">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>

            {/* Facilities skeleton */}
            <div className="mb-4">
              <div className="h-5 bg-gray-300 rounded w-20 mb-2"></div>
              <div className="flex flex-wrap gap-2">
                <div className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded">
                  <div className="w-4 h-4 bg-gray-300 rounded"></div>
                  <div className="h-3 bg-gray-300 rounded w-12"></div>
                </div>
                <div className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded">
                  <div className="w-4 h-4 bg-gray-300 rounded"></div>
                  <div className="h-3 bg-gray-300 rounded w-8"></div>
                </div>
                <div className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded">
                  <div className="w-4 h-4 bg-gray-300 rounded"></div>
                  <div className="h-3 bg-gray-300 rounded w-16"></div>
                </div>
              </div>
            </div>

            {/* Rate selection skeleton */}
            <div className="mb-4">
              <div className="h-5 bg-gray-300 rounded w-24 mb-2"></div>
              <div className="space-y-2">
                <div className="border border-gray-200 rounded-lg p-3">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="h-4 bg-gray-300 rounded w-20 mb-1"></div>
                      <div className="h-3 bg-gray-200 rounded w-32"></div>
                    </div>
                    <div className="text-right">
                      <div className="h-5 bg-gray-300 rounded w-24 mb-1"></div>
                      <div className="h-3 bg-gray-200 rounded w-16"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Price and button skeleton */}
            <div className="mt-auto">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div>
                  <div className="h-3 bg-gray-200 rounded w-16 mb-1"></div>
                  <div className="h-7 bg-gray-300 rounded w-32 mb-1"></div>
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                </div>
                <div className="w-full sm:w-auto">
                  <div className="h-12 bg-gray-300 rounded-lg w-full sm:w-32"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Multiple room skeletons component
export function RoomSkeletonList({ count = 3 }) {
  return (
    <div className="space-y-6">
      {Array.from({ length: count }, (_, index) => (
        <RoomSkeleton key={index} />
      ))}
    </div>
  );
}
